/**
 * Zahlenformatierung wie `value.ToString("N…")` unter deutscher Kultur:
 * Tausenderpunkt, Dezimalkomma, feste Anzahl Nachkommastellen.
 */

export type NumberFormat = 'N0' | 'N2' | 'N4';

const FRACTION_DIGITS: Record<NumberFormat, number> = { N0: 0, N2: 2, N4: 4 };

const formatters = new Map<NumberFormat, Intl.NumberFormat>();

function getFormatter(format: NumberFormat): Intl.NumberFormat {
  let formatter = formatters.get(format);
  if (formatter === undefined) {
    const digits = FRACTION_DIGITS[format];
    formatter = new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
      useGrouping: true,
    });
    formatters.set(format, formatter);
  }
  return formatter;
}

/** Formatiert einen Wert; `null`/`undefined` ergeben einen leeren String. */
export function formatNumber(
  value: number | null | undefined,
  format: NumberFormat = 'N2',
): string {
  if (value === null || value === undefined) return '';
  return getFormatter(format).format(value);
}

/** Liest eine deutsch formatierte Zahl; leere oder ungültige Eingaben ergeben `null`. */
export function parseNumber(text: string): number | null {
  const normalized = text.trim().replace(/\./g, '').replace(',', '.');
  if (normalized === '') return null;

  const value = Number(normalized);
  return Number.isNaN(value) ? null : value;
}
